<template>
    <div class="home">
        <div v-show="isMask" class="mask"></div>
        <!-- <div class="dialog-top">
            <div class="left" style="width: 88px;">
                <span>街区名称</span>
            </div>
            <div class="right">
                <el-form :inline="true" :model="searchForm" ref="searchForm" class="searchForm">
                    <el-form-item class="item" prop="foodStreet">
                        <el-input style="width:190px;" v-model="searchForm.foodStreet" placeholder="输入街区名称" size="small" clearable>
                        </el-input>
                    </el-form-item>
                    <el-form-item v-if="!searchList.reviseObj" class="item" prop="timeList">
                        <el-input style="width:190px;" @click.native="showDatePicker()" readonly v-model="searchForm.timeListStr" placeholder="选择一个或多个日期" size="small" clearable>
                        </el-input>
                        <DatePicker
                            ref="datePickerRef"
                            align="right"
                            style="width:0px;overflow: hidden;height:0;margin-top:-30px"
                            :readonly="false"
                            :theme-start-time="searchList.themeBasic.themeStartTime"
                            :theme-end-time="searchList.themeBasic.themeEndTime"
                            @handleChangeDate="handleChangeDate"
                            />
                        <el-date-picker
                        style="width:190px;"
                        @change="timeChange(searchForm.timeList)"
                        type="dates"
                        value-format="yyyy-MM-dd"
                        v-model="searchForm.timeList"
                        :picker-options="pickerOptions(searchList.themeBasic)"
                        placeholder="选择一个或多个日期"
                        size="small"
                        clearable
                        :default-value="defauleTime"
                        >
                        </el-date-picker>
                    </el-form-item>
                </el-form>
            </div>
        </div> -->

        <div class="dialog-top">
                <div class="left">
                    <div style="display:flex">
                        <div>售点查询</div>
                    </div>
                </div>
                <div class="right">
                    <el-form :inline="true" :model="searchForm" ref="searchForm" class="searchForm">
                        <!-- <el-form-item class="item" prop="igniteStatus" v-if=" selectOptions.igniteStatus.length > 0">
                            <el-select v-if="options"  v-model="searchForm.igniteStatus" placeholder="IGNITE状态" size="small" multiple collapse-tags clearable>
                                <el-option v-for="(item)  in selectOptions.igniteStatus"  :key="item.key" :label="item.value" :value="item.key">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item class="item" prop="igniteStatus" v-else>
                            <el-select v-model="searchForm.igniteStatus" placeholder="IGNITE状态" size="small" multiple collapse-tags clearable>
                                <el-option v-for="(key,value)  in options.igniteStatus"  :key="value" :label="key" :value="value">
                                </el-option>
                            </el-select>
                        </el-form-item> -->
                        <!-- 新注释 -->
                        <!-- <el-form-item class="item" prop="areaCode">
                            <el-select v-model="searchForm.areaCode" placeholder="请选择城市" size="small" style="width: 190px;" clearable>
                                <el-option v-for="(item) in areaCodearr" :key="item.orgCode" :label="item.orgName.split('|')[0]" :value="item.orgCode">
                                </el-option>
                            </el-select>
                        </el-form-item> -->
                        <!-- <el-form-item class="item" prop="tradeStatus" v-if=" selectOptions.openStatus.length > 0">
                            <el-select  v-model="searchForm.tradeStatus" placeholder="售点状态" size="small" multiple collapse-tags clearable>
                            <el-option v-for="(item)  in selectOptions.openStatus"  :key="item.key" :label="item.value" :value="item.key">
                            </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item class="item" prop="tradeStatus" v-else>
                            <el-select v-model="searchForm.tradeStatus" placeholder="售点状态" size="small" multiple collapse-tags clearable>
                            <el-option v-for="(key,value)  in options.openStatus"  :key="value" :label="key" :value="value">
                            </el-option>
                            </el-select>
                        </el-form-item> -->

                        <!-- 本来就注释 -->
                        <!-- <el-form-item class="item" prop="channel" v-if=" selectOptions.channel.length > 0">
                            <el-select v-model="searchForm.channel" placeholder="渠道" size="small" multiple>
                            <el-option v-for="(item)  in selectOptions.channel"  :key="item.key" :label="item.value" :value="item.key">
                            </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item class="item" prop="channel" v-else>
                            <el-select v-model="searchForm.channel" placeholder="渠道" size="small" multiple>
                            <el-option v-for="(key,value)  in options.channel"  :key="value" :label="key" :value="value">
                            </el-option>
                            </el-select>
                        </el-form-item> -->
                        <!-- 新注释 -->
                        <!-- <el-form-item class="item"  prop="businessType" v-if=" selectOptions.bizForm.length > 0">
                            <el-select v-model="searchForm.businessType"  placeholder="业态" size="small" multiple collapse-tags clearable>
                            <el-option v-for="(item)  in selectOptions.bizForm"  :key="item.key" :label="item.value" :value="item.key">
                            </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item class="item"  prop="businessType" v-else>
                            <el-select v-model="searchForm.businessType"  placeholder="业态" size="small" multiple collapse-tags clearable>
                            <el-option v-for="(item)  in options.bizForm"  :key="item.key" :label="item.value" :value="item.key">
                            </el-option>
                            </el-select>
                        </el-form-item> -->

                        <!-- v-if=" searchForm.businessType.length > 0" -->
                        <!-- <el-form-item class="item" prop="childType">
                            <el-select v-model="searchForm.childType" placeholder="子业态" size="small" multiple collapse-tags clearable>
                            <el-option v-for="(item)  in childTypeoptions"  :key="item.key" :label="item.value" :value="item.key">
                            </el-option>
                            </el-select>
                        </el-form-item> -->

                        <!-- <el-form-item class="item" prop="level" v-if=" selectOptions.pocGrade.length > 0 ">
                            <el-select v-model="searchForm.level" placeholder="档次" size="small" multiple collapse-tags clearable>
                            <el-option v-for="(item) in selectOptions.pocGrade" :key="item.key" :label="item.value" :value="item.key">
                            </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item class="item" prop="level" v-else>
                            <el-select v-model="searchForm.level" placeholder="档次" size="small" multiple collapse-tags clearable>
                            <el-option v-for="(key,value) in options.pocGrade" :key="value" :label="key" :value="value">
                            </el-option>
                            </el-select>
                        </el-form-item> -->

                        <!-- <el-form-item class="item" prop="salePotential" v-if=" selectOptions.salesVolume.length > 0">
                            <el-select v-model="searchForm.salePotential" placeholder="销售潜力" size="small" multiple collapse-tags clearable>
                            <el-option v-for="(item)  in selectOptions.salesVolume"  :key="item.key" :label="item.value" :value="item.key">
                            </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item class="item" prop="salePotential" v-else>
                            <el-select v-model="searchForm.salePotential" placeholder="销售潜力" size="small" multiple collapse-tags clearable>
                            <el-option v-for="(key,value)  in options.salesVolume" :key="value" :label="key" :value="value">
                            </el-option>
                            </el-select>
                        </el-form-item> -->

                        <el-form-item class="item" prop="saleName">
                            <el-input  style="width:190px;" v-model="searchForm.saleName" placeholder="输入售点名称" size="small" clearable>
                            </el-input>
                        </el-form-item>
                        <el-form-item class="item" prop="igniteId">
                            <el-input style="width:190px;" v-model="searchForm.igniteId" placeholder="输入abiOneId" size="small" clearable>
                            </el-input>
                        </el-form-item>
                        <el-form-item class="item" style="width:60px;">
                            <el-button type="primary" size="small" @click="clickQuery()">搜索</el-button>
                        </el-form-item>
                    </el-form>
                </div>
        </div>
        <!-- <div class="dialog-warn" style="font-size: 13px;">
            <span>最少关联售点数：{{searchList.pocCountMin  }}</span>
        </div> -->
        <div class="dialog-warn" v-if="tableData.length == 0 && !loading ">
            注：如无法找到售点，请确认售点所属区域/级别等信息是否匹配所选查询条件
        </div>
        <div class="dialog-form" v-loading = 'loading' >
            <!-- empty-text="如无法找到售点，请确认售点所属区域/业态/级别等信息是否匹配所选查询条件" -->
            <el-table
                :data="tableData"
                ref="multipleTable"
                tooltip-effect="dark"
                empty-text
                style="width: 100%;"
                border
                show-header
                row-key="igniteId"
                @selection-change="handleSelectionChange">
                <!-- row-key="pocPoiId" -->
                <el-table-column
                type="selection"
                :reserve-selection = true
                align="center"
                label='全选'
                width="55">
                </el-table-column>
                <el-table-column
                align="center"
                label="城市"
                show-overflow-tooltip
                >
                <template slot-scope="scope">{{ getName(scope.row.areaName)  }}</template>
                </el-table-column>
                <el-table-column
                align="center"
                label="abiOneId"
                >
                <template slot-scope="scope">{{ scope.row.igniteId }}</template>
                </el-table-column>
                <el-table-column
                align="center"
                label="abiOneId"
                >
                <template slot-scope="scope">{{ scope.row.igniteId }}</template>
                </el-table-column>
                <el-table-column
                align="center"
                label="售点名称"
                show-overflow-tooltip
                >
                <template slot-scope="scope">{{ scope.row.pocName }}</template>
                </el-table-column>
                <el-table-column
                align="center"
                label="售点联系人"
                show-overflow-tooltip>
                <template slot-scope="scope">{{ scope.row.contactPerson }}</template>
                </el-table-column>
                <el-table-column
                align="center"
                label="售点联系方式"
                show-overflow-tooltip>
                <template slot-scope="scope">{{ scope.row.contactPhone }}</template>
                </el-table-column>
                <el-table-column
                align="center"
                label="地址"
                show-overflow-tooltip>
                <template slot-scope="scope">{{ scope.row.pocAddress }}</template>
                </el-table-column>
            </el-table>
        </div>
        <div class="dialog-bottom" v-if="tableData.length > 0">
            <el-pagination
            background
            :total="searchForm.total"
            layout="total, prev, pager, next"
            :current-page="searchForm.page"
            :page-size="searchForm.pageSize"
            @current-change="handleCurrentChange">
            <span style="text-align: center">{{searchForm.page}}/{{allPage}}</span>
        </el-pagination>
        </div>
        <div class="dialog-selected" style="margin-bottom: 5px;">
            <div class="selected-top">已选择：</div>
            <div class="selected-tag">
                <el-tag
                v-for="tag in tags"
                :key="tag.pocPoiId"
                closable
                :disable-transitions= 'false'
                @close="handleClosetag(tag)"
                type="danger">
                {{tag.pocName}}
                </el-tag>
            </div>
        </div>
        <div class="line"></div>
        <div class="dialog-top" style="margin-top: 5px;">
            <div class="left" style="width: 88px;">
                <span>提报信息</span>
            </div>
            <div class="right">
                <el-form :inline="true" :model="searchForm" ref="searchForm" class="searchForm">
                    <el-form-item class="item" prop="foodStreet">
                        <el-input style="width:190px;" v-model="searchForm.foodStreet" placeholder="输入街区名称" size="small" clearable>
                        </el-input>
                    </el-form-item>
                    <!-- <el-form-item v-if="!searchList.reviseObj" class="item" prop="timeList">
                        <el-date-picker
                        style="width:190px;"
                        @change="timeChange(searchForm.timeList)"
                        type="dates"
                        value-format="yyyy-MM-dd"
                        v-model="searchForm.timeList"
                        :picker-options="pickerOptions(searchList.themeBasic)"
                        placeholder="选择一个或多个日期"
                        size="small"
                        clearable
                        :default-value="defauleTime"
                        >
                        </el-date-picker>
                    </el-form-item> -->
                    <el-form-item v-if="!searchList.reviseObj" class="item" prop="timeList">
                        <el-input style="width:190px;" @click.native="showDatePicker()" readonly v-model="searchForm.timeListStr" placeholder="选择一个或多个日期" size="small" clearable>
                        </el-input>
                        <DatePicker
                            ref="datePickerRef"
                            align="right"
                            style="width:0px;overflow: hidden;height:0;margin-top:-30px"
                            :readonly="false"
                            :theme-start-time="searchList.themeBasic.themeStartTime"
                            :theme-end-time="searchList.themeBasic.themeEndTime"
                            @handleChangeDate="handleChangeDate"
                            />
                        <!-- <el-date-picker
                        style="width:190px;"
                        @change="timeChange(searchForm.timeList)"
                        type="dates"
                        value-format="yyyy-MM-dd"
                        v-model="searchForm.timeList"
                        :picker-options="pickerOptions(searchList.themeBasic)"
                        placeholder="选择一个或多个日期"
                        size="small"
                        clearable
                        :default-value="defauleTime"
                        >
                        </el-date-picker> -->
                    </el-form-item>
                </el-form>
            </div>
        </div>
        <div class="dialog-btn">
            <div class="btn-left" @click="closeDialog" >取消</div>
            <div class="btn-right" @click= 'clickOk'>确定</div>
            <!-- <div class="btn-right" v-if="searchList.router == '06'" @click= 'clickOkupdate()'>确定</div>
            <div class="btn-right"  v-else @click= 'clickOk()'>确定</div> -->
        </div>

        <div class="dialog-close" @click="closeDialog()">
            <i class="el-icon-close" style="font-size: 28px;"></i>
        </div>
        <!-- -->
        <div class="dialog-update" v-if="isShowupdate"  >
        <el-table
            :data="updatedList"
            ref="updateTable"
            show-header
            class="update-table"
            :span-method="objectSpanMethod"
            style="width: 100%">
            <el-table-column
            prop="block_name"
            label="街区名称"
            align="center"
            width="90"
            show-overflow-tooltip
            >
            </el-table-column>

            <el-table-column
            prop="pocName"
            label="门店名称"
            align="center"
            width="90"
            show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
            label="门店联系人"
            align="center"
            >
            <template slot-scope="scope">
                <el-input class="item-input" size="mini" v-model="scope.row.contactPerson"  @change="changeInput" clearable>{{ scope.row.contactPerson }}</el-input>
            </template>
            </el-table-column>
            <el-table-column
            label="联系人手机号"
            align="center"
            >
            <template slot-scope="scope">
                <el-input  class="item-input" size="mini" v-model="scope.row.contactPhone"  @change="changeInput" clearable>{{ scope.row.contactPhone }}</el-input>
            </template>
            </el-table-column>
            <el-table-column
            label="百威联系人"
            align="center"
            >
            <template slot-scope="scope">
                <el-input  class="item-input" size="mini" v-model="scope.row.bwContactPerson"  @change="changeInput(scope.row)" clearable>{{ scope.row.bwContactPerson }}</el-input>
            </template>
            </el-table-column>
        </el-table>
        <div class="dialog-btn2">
            <div class="btn-left" @click="closeSure()" >取消</div>
            <div class="btn-right"  @click= 'updateSure()'>确定</div>
        </div>
        </div>

    </div>
</template>
<script>
    import DatePicker from "../components/date-picker";
    import { parseTime } from '@/filters'
    import { mapGetters } from 'vuex'
    import gameplanApi from '../../../api/gameplan';
    export default {
      name: 'activity-report-many-point',
      props: {
        // dataList:{type:object,default:()=>{}},
        options:{type:Object,default:()=>{}},
        searchList:{type:Object,default:()=>{}},
      },
      components: {
        DatePicker
      },
      data () {
        return {
            tableData: [],
            searchForm: {
                igniteStatus: [],
                tradeStatus: [],
                channel: [],
                businessType: [],
                level: [],
                salePotential: [],
                saleName: '',
                foodStreet:'',// 食街
                pageSize:10,
                page:1,
                total:0,
                childType:[],
                bwContactPerson:'', // 百威联系人
                areaCode: '',
                timeList:[],
                igniteId: '',
                timeListStr:''
            },
            tags: [],
            themeDetailId: '',
            multipleSelection:[],
            selectOptions:[],
            isQueryfirst:false,
            startFoodstreet: '',
            pocRelateType: '',
            multipleSelectionAgain:[],
            loading:true,
            allPage:0,
            blockNamearr:[],
            lastRouter:'',
            streetArr: [], // 街道数组
            streeIndex:0, // 下标
            updatedList:[],
            isShowupdate: false,
            isMask:false,
            areaCodearr: [],
            defauleTime:'',
            pickerOptions(row = {}) {
                return{
                    disabledDate (time) {
                        return time.getTime() > row.themeEndTime ||  time.getTime() < row.themeStartTime
                    }
                }
            },
            pickerOptionschange(row = {}) {
                return{
                    disabledDate (time) {
                        return time.getTime() < Date.now() - 8.64e7 ||  time.getTime() > row.themeEndTime ||  time.getTime() < row.themeStartTime
                    }
                }
            },
        }
      },
      computed: {
        ...mapGetters(['userInfo']),
        // childTypeoptions () {
        //     let arr = []
        //     for (let item1 in this.options.subBizForm) {
        //         let obj = {}
        //         obj[item1] = this.options.subBizForm[item1]
        //         for (let item2 of this.searchForm.businessType) {
        //             if ( item1.substr(0,10) == item2) {
        //                 arr.push({key:item1,value:obj[item1]})
        //             }
        //         }
        //     }
        //     return arr
        // }
      },
      watch: {},
      created () {
        this.pocRelateType = this.searchList.pocRelateType
        this.themeDetailId = this.searchList.themeDetailId
        this.blockNamearr =  this.searchList.blockNamearr
        // this.defauleTime = new Date(this.searchList.themeBasic.themeStartTime);
        // this.defauleTime.setMonth(new Date(this.searchList.themeBasic.themeStartTime).getMonth());
        if (this.searchList.router) {
            this.lastRouter =  this.searchList.router
        }
        // if (this.searchList.igniteRuleObj.bizForm.length  ==  0) {
        //     if (this.searchList.themeCode.substr(0,2) == '01') {
        //         this.options.bizForm = [
        //             {'key':'2022010103','value':"大排档"},
        //             {'key':'2022010104','value':"火锅"},
        //             {'key':'2022010105','value':"烧烤/小龙虾"},
        //             {'key':'2022010106','value':"中式正餐"},
        //             {'key':'2022010201','value':"夜总会"},
        //             {'key':'2022010202','value':"KTV"},
        //             {'key':'2022010203','value':"慢摇吧"},
        //             {'key':'2022010204','value':"酒吧"},
        //             {'key':'2022010205','value':"餐吧"},
        //         ]
        //     }
        //     else if (this.searchList.themeCode.substr(0,2) == '02') {
        //         this.options.bizForm = [
        //             {'key':'2022010103','value':"大排档"},
        //             {'key':'2022010104','value':"火锅"},
        //             {'key':'2022010105','value':"烧烤/小龙虾"},
        //             {'key':'2022010106','value':"中式正餐"}
        //         ]
        //     }
        //     else if (this.searchList.themeCode.substr(0,2) == '03') {
        //         this.options.bizForm = [
        //             {'key':'2022010203','value':"慢摇吧"},
        //         ]
        //     }
        //     else if (this.searchList.themeCode.substr(0,2) == '04') {
        //         this.options.bizForm = [
        //             {'key':'2022010201','value':"夜总会"},
        //             {'key':'2022010202','value':"KTV"}
        //         ]
        //     }
        //     else if (this.searchList.themeCode.substr(0,2) == '05') {
        //         this.options.bizForm = [
        //             {'key':'2022010204','value':"酒吧"},
        //             {'key':'2022010205','value':"餐吧"}
        //         ]
        //     }
        //     else if (this.searchList.themeCode.substr(0,2) == '06') {
        //         this.options.bizForm = [
        //             {'key':'2022010204','value':"酒吧"},
        //             {'key':'2022010205','value':"餐吧"}
        //         ]
        //     }
        //     else if (this.searchList.themeCode.substr(0,2) == '07') {
        //         this.options.bizForm = [
        //             {'key':'2022010102','value':"外国餐厅"},
        //             {'key':'2022010204','value':"酒吧"},
        //             {'key':'2022010205','value':"餐吧"}
        //         ]
        //     }
        //     else if (this.searchList.themeCode.substr(0,2) == '08') {
        //         this.options.bizForm = [
        //             {'key':'2022010102','value':"外国餐厅"},
        //             {'key':'2022010204','value':"酒吧"},
        //             {'key':'2022010205','value':"餐吧"}
        //         ]
        //     }
        //     else if (this.searchList.themeCode.substr(0,2) == '09') {
        //         this.options.bizForm = [
        //             {'key':'2022010102','value':"外国餐厅"},
        //             {'key':'2022010204','value':"酒吧"},
        //             {'key':'2022010205','value':"餐吧"}
        //         ]
        //     }
        //     else {
        //         this.options.bizForm = []
        //     }
        // }
        // let arr1 = []
        // let arr2 = []
        // let arr3 = []
        // let arr4 = []
        // let arr5 = []
        // let arr6 = []
        // if (this.searchList.igniteRuleObj.igniteStatus.length > 0) {
        //     this.searchForm.igniteStatus = this.searchList.igniteRuleObj.igniteStatus
        // } else {
        //     this.searchForm.igniteStatus = arr1
        // }
        // if (this.searchList.igniteRuleObj.openStatus.length > 0) {
        //     this.searchForm.tradeStatus = this.searchList.igniteRuleObj.openStatus
        // } else {
        //     this.searchForm.tradeStatus = arr2
        // }
        // if (this.searchList.igniteRuleObj.bizForm.length > 0) {
        //     this.searchForm.businessType = this.searchList.igniteRuleObj.bizForm
        // } else {
        //     this.searchForm.businessType = arr4
        // }
        // if (this.searchList.igniteRuleObj.pocGrade.length > 0) {
        //     this.searchForm.level = this.searchList.igniteRuleObj.pocGrade
        // } else {
        //     this.searchForm.level = arr5
        // }
        // if (this.searchList.igniteRuleObj.salesVolume.length > 0) {
        //     this.searchForm.salePotential = this.searchList.igniteRuleObj.salesVolume
        // } else {
        //     this.searchForm.salePotential = arr6
        // }
        if (this.searchList.reviseObj) {
            this.searchForm.foodStreet = this.searchList.reviseObj.foodStreet
            this.multipleSelectionAgain = this.searchList.reviseObj.selectList
            this.tags = this.searchList.reviseObj.selectList
            this.startFoodstreet = this.searchList.reviseObj.foodStreet
            this.searchForm.bwContactPerson = this.searchList.reviseObj.bwContactPerson
            this.searchForm.timeList = this.searchList.reviseObj.timeList
        }
        this.init()
        console.log(this.searchList,'多售点----searchList');
      },
      mounted () {},
      updated () {},
      methods: {
        init () {
            // this.getSelectList()
            // this.getQueryarea()
            this.getSaleList()
        },
        getName(str){
            if(str){
                return str.split('|')[0] || str
            }else return ''
        },
        showDatePicker(){
          const timeList = this.searchForm.timeList.map(item=>{
            const date = new Date(item.replace(/-/g, '/'))
            return date.getTime()
           })
          this.$refs.datePickerRef.showDatePicker(timeList)
        },
        handleChangeDate(dateList){
          this.searchForm.timeList = dateList
          this.searchForm.timeListStr = dateList.join(',')
          this.$refs.datePickerRef.hideDatePicker()
        },
        // 已添加
        addNumber (addArr) {
            let allNum = 0
            if (this.searchList.needTransitions == 0) {
                let arr = []
                for (let item of addArr) {
                    arr.push(item)
                }
                allNum = 1
                return allNum
            }
            else if (this.searchList.needTransitions == 1) {
                let arr = []
                for (let item of addArr) {
                    arr.push(item)
                }
                allNum = allNum + arr[0].timeList.length
                return allNum
            }
        },
        // 时间选择
        timeChange (time){
            // console.log(time,'time');
        },
        getTime (timestamp) {
            if (timestamp === 0 || timestamp == null) {
                return ''
            } else {
                var date = new Date(parseInt(timestamp)) // 时间戳为13位的话需要parseInt下
                const Y = date.getFullYear() + '-'
                const M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
                const D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' '
                // const h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':'
                // const m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':'
                // const s = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds())
                return Y + M + D
            }
        },
        async getQueryarea () {
            let params = {
                'regionCode':this.searchList.regionCode
            }
           let res = await gameplanApi.getQueryarea(params)
           if (res.data.resultCode == '0') {
            this.areaCodearr = res.data.resultData.regionList
            if (this.searchList.reviseObj) {
                this.searchForm.areaCode = this.searchList.reviseObj.areaCode
            } else {
                // this.searchForm.areaCode = this.areaCodearr[0].orgCode
            }
            this.getSaleList()
           }
        },
        getSelectList () {
            let igniteStatus = {}
            let arr1 =[]
            let arr2 =[]
            let arr3 =[]
            let arr4 =[]
            let arr5 =[]
            let arr6 =[]
            for (let item1 in this.options.igniteStatus) {
                let obj = {}
                obj[item1] = this.options.igniteStatus[item1]
                for (let item2 of this.searchList.igniteRuleObj.igniteStatus) {
                    if (item1 == item2) {
                        arr1.push({key:item1,value:obj[item1]})
                    }
                }
            }
            for (let item1 in this.options.openStatus) {
                let obj = {}
                obj[item1] = this.options.openStatus[item1]
                for (let item2 of this.searchList.igniteRuleObj.openStatus) {
                    if (item1 == item2) {
                        arr2.push({key:item1,value:obj[item1]})
                    }
                }
            }
            for (let item1 in this.options.channel) {
                let obj = {}
                obj[item1] = this.options.channel[item1]
                for (let item2 of this.searchList.igniteRuleObj.channel) {
                    if (item1 == item2) {
                        arr3.push({key:item1,value:obj[item1]})
                    }
                }
            }
            for (let item1 in this.options.bizForm) {
                let obj = {}
                obj[item1] = this.options.bizForm[item1]
                for (let item2 of this.searchList.igniteRuleObj.bizForm) {
                    if (item1 == item2) {
                        arr4.push({key:item1,value:obj[item1]})
                    }
                }
            }
            for (let item1 in this.options.pocGrade) {
                let obj = {}
                obj[item1] = this.options.pocGrade[item1]
                for (let item2 of this.searchList.igniteRuleObj.pocGrade) {
                    if (item1 == item2) {
                        arr5.push({key:item1,value:obj[item1]})
                    }
                }
            }
            for (let item1 in this.options.salesVolume) {
                let obj = {}
                obj[item1] = this.options.salesVolume[item1]
                for (let item2 of this.searchList.igniteRuleObj.salesVolume) {
                    if (item1 == item2) {
                        arr6.push({key:item1,value:obj[item1]})
                        // arr6.push(this.options.salesVolume[item1])
                    }
                }

            }
            this.selectOptions.igniteStatus= arr1
            this.selectOptions.openStatus= arr2
            this.selectOptions.channel= arr3
            this.selectOptions.bizForm= arr4
            this.selectOptions.pocGrade= arr5
            this.selectOptions.salesVolume= arr6


        },
        async getSaleList () {
            let params = {
                'page':this.searchForm.page,
                'pageSize':this.searchForm.pageSize,
                'themeDetailId':this.themeDetailId,
                // // 'igniteStatus':this.searchForm.igniteStatus.join(','),
                // 'openStatus':this.searchForm.tradeStatus.join(','),
                // 'channel':this.searchForm.channel.join(','),
                // 'bizForm':this.searchForm.businessType.join(','),
                // 'pocGrade':this.searchForm.level.join(','),
                // // 'salesVolume':this.searchForm.salePotential.join(','),
                // 'subBizForm':this.searchForm.childType.join(','),
                // 'areaCode':this.searchForm.areaCode,
                'pocSelfDefinedName':this.searchForm.saleName,
                'regionCode':this.searchList.regionCode,
                'igniteId':this.searchForm.igniteId
            }
            this.loading = true
            let res = await gameplanApi.getGamepalnSalequery(params)
                if (res.data.resultCode == '0') {
                    this.loading = false
                    let  pageInfo = res.data.resultData.pageInfo
                    let tableData = res.data.resultData.pocList
                    // this.allPage = Math.ceil(this.searchForm.total/ this.searchForm.pageSize)
                    this.searchForm.total = pageInfo.totalCounts
                    this.allPage = pageInfo.totalPages
                    this.tableData = tableData
                    if (this.multipleSelectionAgain.length > 0) {
                        this.$nextTick(()=>{
                            let  multipleSelectionAgain = this.multipleSelectionAgain
                            // let tableData =  this.tableData
                            // console.log(tableData,'this.tableData');
                            let arr = []
                            for (let item of multipleSelectionAgain) {
                                // pocPoiId  暂时改为 pocName
                                arr.push(item.igniteId)
                            }
                            this.tableData.forEach(row => {
                                if(arr.indexOf(row.igniteId) >= 0){
                                    this.$refs.multipleTable.toggleRowSelection(row,true);
                                }
                            })
                        })
                    }
                } else {
                    console.log('error');
                    this.loading = false
                }
        },
        // 页码
        handleCurrentChange (val) {
            this.searchForm.page = val
            this.getSaleList()
        },
        closeDialog () {
            this.multipleSelection = []
            this.$refs.multipleTable.clearSelection();
            this.searchForm   = this.$options.data().searchForm
            this.tags = this.$options.data().tags
            this.$emit('closeMask')

        },
        clickOk () {
            let timeStamp = new Date().getTime()
            if (this.blockNamearr && !this.startFoodstreet  && !this.lastRouter) {
                for (let item of this.blockNamearr) {
                    if (item == this.searchForm.foodStreet) {
                        this.$message.warning('街区已存在，请重新输入')
                        return
                    }
                }
            }
            if (this.searchList.needTransitions == 0 && !this.searchList.reviseObj) {
                if (this.searchList.perExecDays && this.searchForm.timeList !== null) {
                    if (this.searchForm.timeList.length  !== this.searchList.perExecDays) {
                        this.$message.error(`选择日期天数应与执行天数相等,当前已选 ${this.searchForm.timeList.length}天，应选 ${this.searchList.perExecDays}天`)
                        return
                    }
                } else {
                    // this.$message.warning('配置天数未返回')
                    // return
                }
            }
            if (!this.searchList.reviseObj) {
                if (this.searchForm.timeList == null || this.searchForm.timeList.length == 0) {
                    this.$message.warning('您未选择时间')
                    return
                }
            }
            if (this.searchForm.foodStreet == '' ) {
                this.$message.error('抱歉，您未输入街区名称');
                return
            }
            if (this.multipleSelection.length  < this.searchList.pocCountMin) {
                this.$message.error(`抱歉，您添加售点数量小于最小关联售点: ${this.searchList.pocCountMin}`);
                return
            }
            // if (this.searchList.igniteIdarr.length > 0 && !this.searchList.reviseObj) {
            //     for (let item1 of this.searchList.igniteIdarr) {
            //         for (let item2 of this.multipleSelection) {
            //             if (item1 == item2.igniteId) {
            //                 let name = item2.pocName
            //                 this.$message.error(`抱歉，您已添加过${name},不能重复添加`);
            //                 return
            //             }
            //         }
            //     }
            // }
            // if (this.searchList.reviseObj) {
            //     let revIgnitearr = JSON.parse(JSON.stringify(this.searchList.igniteIdarr))
            //     for (let i = 0; i < revIgnitearr.length; i++) {
            //         for (let item2 of this.searchList.reviseObj.selectList) {
            //             if (revIgnitearr[i] == item2.igniteId) {
            //                 revIgnitearr.splice(i,1)
            //             }
            //         }
            //     }
            //     // console.log(revIgnitearr,'revIgnitearr')
            //     if (revIgnitearr.length > 0) {
            //         for (let item1 of revIgnitearr) {
            //             for (let item2 of this.multipleSelection) {
            //                 if (item1 == item2.igniteId) {
            //                     let name = item2.pocName
            //                     this.$message.error(`抱歉，您已添加过${name},不能重复添加`);
            //                     return
            //                 }
            //             }
            //         }
            //     }
            // }
            let selectList = this.multipleSelection
            let  arr = JSON.parse(JSON.stringify(selectList))
            for (let i = 0; i < arr.length; i++) {
                arr[i].block_name = this.searchForm.foodStreet
                arr[i].startFoodstreet =this.startFoodstreet
                arr[i].bwContactPerson = this.searchForm.bwContactPerson
                arr[i].timeList = this.searchForm.timeList
                arr[i].regionCode = this.searchList.regionCode
                arr[i].timeStamp = timeStamp
            }
            // for (let i = 0; i < arr.length; i++) {
            //     for (let j = i+1; j < arr.length; j++) {
            //         if (arr[i].areaCode !== arr[j].areaCode ) {
            //             this.$message.error('所选售点不属于同一个城市')
            //             return
            //         }
            //     }
            // }
            let number = this.addNumber(arr)
            // console.log(number,'number-当前',this.searchList.noAddnumber,'.noAddnumber-剩余')
            if (number > this.searchList.noAddnumber && !this.searchList.reviseObj) {
                // this.$message.warning(`添加场次超出未提报场次,已选择${number}场，剩余${this.searchList.noAddnumber}场`)
                this.$message.warning('添加场次超出未提报场次')
                return
            }
            if (!this.searchList.activityReturn) {
                this.$emit('handleSelectionChange',arr)
            } else {
                this.$emit('handleSelectionChangereturn',arr)
            }
            this.searchForm   = this.$options.data().searchForm
            this.multipleSelection = []
            this.$refs.multipleTable.clearSelection();
            this.tags = this.$options.data().tags
            this.$emit('closeMask')
        },
        clickQuery () {
            this.searchForm.page = 1
            this.getSaleList()
        },
        handleClosetag (tag) {
            this.tags.splice(this.tags.indexOf(tag), 1);
            this.tags = this.multipleSelection
            this.toggleSelection(tag)
        },
        toggleSelection(rows) {
            this.$refs.multipleTable.toggleRowSelection(rows,false);
        },
        handleSelectionChange (val) {
            this.multipleSelection = val
            this.tags = this.multipleSelection
        },
        // 初始化合并行数组
        mergeInit() {
            this.streetArr = []; //合并街道
            this.streeIndex = 0; //合并街道索引
        },
        //  合并表格
        merge(data) {
            this.mergeInit();
            if (data.length > 0) {
                for (var i = 0; i < data.length; i++) {
                    if (i === 0) {
                        //第一行必须存在，以第一行为基准
                        this.streetArr.push(1); //合并医院
                        this.streeIndex = 0;
                    } else {
                        // 判断当前元素与上一元素是否相同
                        // 合并街区列
                        if (data[i].block_name == data[i - 1].block_name) {
                        this.streetArr[this.streeIndex] += 1;
                        this.streetArr.push(0);
                        } else {
                        this.streetArr.push(1);
                        this.streeIndex = i;
                        }
                    }
                }
            }
        },
        objectSpanMethod({ row, column, rowIndex, columnIndex }) {
            const len = this.tableData.length;
                 if(columnIndex === 0 || columnIndex === 4){
                    console.log('00000');
                    const _row_1 = this.streetArr[rowIndex];
                    const _col_1 = _row_1 > 0 ? 1 : 0;
                    return {
                    rowspan: _row_1,
                    colspan: _col_1,
                };
            }
        },
        changeInput (row) {
            if (row) {
                for (let item of this.updatedList) {
                    item.bwContactPerson = row.bwContactPerson
                }
            }
        },
        clickOkupdate () {
            if (this.blockNamearr && !this.startFoodstreet  && !this.lastRouter) {
                for (let item of this.blockNamearr) {
                    if (item == this.searchForm.foodStreet) {
                        this.$message.warning('街区已存在，请重新输入')
                        return
                    }
                }
            }
            if (this.searchForm.foodStreet == ''  ||  this.multipleSelection.length  < this.searchList.pocCountMin) {
                this.$message.error('抱歉，您未输入街区名称或添加售点数量小于最小关联售点');
            } else {
                let  updatedList = JSON.parse(JSON.stringify(this.multipleSelection))
                for (let item of updatedList) {
                    item.block_name = this.searchForm.foodStreet
                    // item.startFoodstreet = this.startFoodstreet
                    // item.bwContactPerson = this.searchForm.bwContactPerson
                }
                this.updatedList = updatedList
                this.merge(this.updatedList)
                this.isMask = true
                this.isShowupdate = true
            }
        },
        updateSure () {
            // console.log(this.updatedList,'updateSure');
            this.isMask = false
            this.isShowupdate = false
            this.$emit('handleSelectionChange',this.updatedList)
            this.searchForm   = this.$options.data().searchForm
            this.multipleSelection = []
            this.$refs.multipleTable.clearSelection();
            this.tags = this.$options.data().tags
            this.$emit('closeMask')
        },
        closeSure () {
            console.log('closeSure');
            this.isMask = false
            this.isShowupdate = false
        }
    }
}
</script>
<style lang="scss" scoped>
    .home {
        position: relative;
        .dialog-top {
            display: flex;
            // height: 100px;
            color: #101010;
            .left {
                width: 88px;
                line-height: 40px;
                font-size: 16px;
                text-align: left;
                font-weight: bold;
                // margin-top: 5px;
            }
            .right {
                flex: 1;
                .searchForm {
                    width: 100%;
                    .item {
                        width: 190px;
                        line-height: 40px;
                        margin: 0px 10px 0px 0px;
                    }
                    .item-selected {
                        line-height: 40px;
                        // max-height: 60px;
                        overflow: hidden;
                        .selected-tag {
                            ::v-deep .el-tag {
                                margin-right: 5px;
                                // margin-bottom: 5px;
                            }
                        }
                    }
                }
            }
        }
        .dialog-warn {
            line-height: 30px;
            height: 30px;
            font-size: 12px;
            color: #cd1231;
        }
        .dialog-form {
            margin-bottom: 20px;
            overflow: hidden;
            overflow-y:scroll;
            max-height: 40vh;
            // height: 80%;
            ::v-deep .el-table th.el-table__cell {
                color: #101010;
                background-color: rgba(232, 232, 232);
            }
            ::v-deep .el-table__body tr.current-row>td.el-table__cell {
                background-color: #FFFFFF !important;
            }
            ::v-deep .el-table--enable-row-hover .el-table__body tr:hover > td {
                background-color: #FFFFFF !important;
            }
        }
        .dialog-bottom {
            position: relative;
            top: 0px;
            text-align: right;
            // ::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
            // background-color: #fff;
            // color: #409EFF;
            // border: 1px solid #409EFF
            // }
            // ::v-deep .el-pagination.is-background .el-pager li:hover {
            // color: #409EFF;
            // }
            ::v-deep .el-pagination.is-background .btn-next,
            ::v-deep .el-pagination.is-background .btn-prev{
                background-color: #FFFFFF;
                color: #000;
                // width: 66px;
                border: 1px solid #C0C4CC;
                border-radius: 3px;
            }
            ::v-deep .el-pagination.is-background .btn-next:disabled,
            ::v-deep .el-pagination.is-background .btn-prev:disabled,
            ::v-deep .el-pagination.is-background .el-pager li.disabled {
                color: #C0C4CC;
            }
        }
        .dialog-selected {
            overflow: hidden;
            overflow-y:scroll;
            max-height: 100px;
            .selected-tag {
                margin-top: 5px;
                ::v-deep .el-tag {
                    margin-right: 5px;
                    margin-bottom: 5px;
                    // color: #cd1231;
                    // background-color:rgb(249, 224, 228);
                }
            }
        }
        .dialog-btn {
            height: 30px;
            line-height: 30px;
            display: flex;
            justify-content:flex-end;
            .btn-left {
                width: 80px;
                text-align: center;
                background-color: #FFFFFF;
                color: #cd1231;
                border-radius: 5px;
                border: 1px solid #cd1231;
                margin-right: 10px;
                cursor: pointer;
            }
            .btn-right {
                width: 80px;
                text-align: center;
                background-color: #cd1231;
                color: #FFFFFF;
                border-radius: 5px;
                border: 1px solid #cd1231;
                cursor: pointer;
            }
        }
        .dialog-close {
            width: 30px;
            height: 30px;
            position: absolute;
            top: 0px;
            right: 10px;
            cursor: pointer;
        }
        .mask{
            position: fixed;
            width: 100%;
            height: 100%;
            top: 0;
            left: 0;
            background: rgba(0,0,0,.7) ;
            z-index: 3;
        }
        .dialog-update{
            position: absolute;
            border-radius: 8px;
            width: 90%;
            top: 10%;
            left: 5%;
            padding: 10px;
            max-height: 300px;
            z-index: 5;
            ::v-deep .el-table th.el-table__cell {
                color: #101010;
                background-color: rgba(232, 232, 232);
            }
            ::v-deep .el-table__body tr.current-row>td.el-table__cell {
                background-color: #FFFFFF !important;
            }
            ::v-deep .el-table--enable-row-hover .el-table__body tr:hover > td {
                background-color: #FFFFFF !important;
            }
            .update-table{
                width: 80%;
                border-radius: 8px;
                .item-input {
                    width: 140px;
                }
            }

            .dialog-btn2 {
                margin-top: 10px;
                height: 30px;
                line-height: 30px;
                display: flex;
                justify-content:flex-end;
                .btn-left {
                    width: 80px;
                    text-align: center;
                    background-color: #FFFFFF;
                    color: #cd1231;
                    border-radius: 5px;
                    border: 1px solid #cd1231;
                    margin-right: 10px;
                    cursor: pointer;
                }
                .btn-right {
                    width: 80px;
                    text-align: center;
                    background-color: #cd1231;
                    color: #FFFFFF;
                    border-radius: 5px;
                    border: 1px solid #cd1231;
                    cursor: pointer;
                }
        }

        }
        .line {
            border:1px dashed #000000;
            height:0;
            opacity: 0.1;
        }
    }

</style>
